var map = {
	"./de/gotoTOPbg.png": "ry/h",
	"./en/gotoTOPbg.png": "egIm",
	"./es/gotoTOPbg.png": "bu5v",
	"./fr/gotoTOPbg.png": "lmNG",
	"./ja/gotoTOPbg.png": "/vuI",
	"./ko/gotoTOPbg.png": "H6ha",
	"./pt/gotoTOPbg.png": "1uNA",
	"./ru/gotoTOPbg.png": "/KMC",
	"./tc/gotoTOPbg.png": "m8rQ",
	"./th/gotoTOPbg.png": "mvT2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "L69e";